/**
 * Created by Ning Jiang on 12/7/2016.
 */

import {ReelSpriteSymbol} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbol";
import {ReelSymbolStates} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import {WGGameConfig} from "../../WGGameConfig";
import {ISymbolAnimationConf} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/IReelSymbolData";
import {TimelineMax} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

export class IReelSymbolStates extends ReelSymbolStates {
    public static readonly NOWIN: string = "noWin";
}

export interface IParsedStackedSymbolName {
    isStacked: boolean;
    symName: string;
    totalNum: number;
    index: number;
}

export class WGSpriteSymbol extends ReelSpriteSymbol {
    private _winAnimation: PIXI.spine.Spine;

    public changeState(newStateConfig: ISymbolAnimationConf): TimelineMax | null {
        // added this check remove alpha from symbol when state change to anything except nowin
        if (this.getChildByName("noWinAlpha")) {
            this.removeChild(this.getChildByName("noWinAlpha"));
        }
        if (newStateConfig.state !== IReelSymbolStates.NOWIN && (this.isScatter || this.isWild || !this.isLowValue)) {
            (this.children[1] as PIXI.Sprite).tint = 16777215;
        }

        if (this.state.lastState === IReelSymbolStates.NOWIN) {
            this.attentionDarkness(0,0.25);
        }

        return super.changeState(newStateConfig);
    }

    public attentionDarkness(alpha: number, duration: number): TimelineMax {
        this._subTimeline = Helper.timeLineKiller(this._subTimeline!,new TimelineMax());
        if(this._overlaySprite.texture != this.currentStateAnim!.texture){
            this._overlaySprite.texture = this.currentStateAnim!.texture;
            this._overlaySprite.tint = 0x000000;
        }
        if(this._overlaySprite.alpha != alpha){
            const fromAlpha:number = this._overlaySprite.alpha;
            this._subTimeline.fromTo(this._overlaySprite,duration,{alpha:fromAlpha}, {alpha:alpha});
        }
        return this._subTimeline;
    }

    protected getStateAnimation(config: ISymbolAnimationConf): TimelineMax {
        this._timeLine = Helper.timeLineKiller(this._timeLine!, new TimelineMax(), true);

        switch (config.state) {
            case ReelSymbolStates.NORMAL:
                this.attentionDarkness(0,0.25); // to fix #134
                this.textureAnimation(config);
                this._symbolState.set(config.state);
                break;
            case ReelSymbolStates.SPIN:
                this.textureAnimation(config);
                this.attentionDarkness(0.24,0.25); // to fix #134
                this._symbolState.set(config.state);
                break;
            case ReelSymbolStates.CHANGE_SYMBOL:
                config.state = this._symbolState.state;
                this.textureAnimation(config);
                break;
            case ReelSymbolStates.TRANSFORM:
                this.playTransformAnimation(config);
                break;
            case ReelSymbolStates.IDLE:
                this.playSymbolAnimation("_idle"); // warriorGraveyard
                break;
            case ReelSymbolStates.WIN:
                this.attentionDarkness(0,0.25); // to fix #101
                this.playSymbolAnimation("_win"); // warriorGraveyard
                break;
            case ReelSymbolStates.LANDING:
                this.playLandingAnimation(); // warriorGraveyard
                break
            case ReelSymbolStates.ATTENTION:
                this.playAttention(config);
                break;
            case ReelSymbolStates.STICKY:
                this.playSticky(config);
                break;
            case ReelSymbolStates.HIDE:
            case ReelSymbolStates.SHOW:
                this.ChangeVisibility(config)
                this._symbolState.set(config.state);
                break;
            case IReelSymbolStates.NOWIN:
                this._symbolState.set(config.state);
                // increased 0.4-> 0.7  to fix #129
                this.attentionDarkness(WGGameConfig.NO_WIN_ALPHA,0.25);
                break;
            default:
                Logger.warn("Using Unknown SymbolState: " + config.state);
                break;
        }
        return this._timeLine;
    }

    /**
     * function to play low symbol animation, scatter-> win and idle animation
     * @param animType
     */
    private playSymbolAnimation(animType: string): void {
        if (WGGameConfig.instance.SPINE_ASSETS.indexOf(this.symName) > -1) {
            const symName = this.symName.toLocaleLowerCase();
            this._winAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(symName));
            this._winAnimation.visible = false;
            this.addChild(this._winAnimation);
            this._timeLine?.add(() => {
                this._winAnimation.updateTransform();
                this._winAnimation.visible = true;
                this.setVisibleForSymbol(false); // to hide the symbol from behind when animation is playing
            });
            this._timeLine?.add(new SpineTween(this._winAnimation, 0, symName + animType));
            this._timeLine?.add(() => {
                this.removeChild(this._winAnimation);
                this.setVisibleForSymbol(true); // to show the symbol  when animation is completed
            });
        }
    }

    /**
     * function to play Landing Animation
     * only for scatter as of now.
     */
    private playLandingAnimation(): void {
        if (this.isScatter) {
            this._winAnimation = this.addChild(new PIXI.spine.Spine(GameResources.getSpineAsset("s")));
            this._winAnimation.alpha = 0;
            this._timeLine = Helper.timeLineKiller(this._timeLine!, new TimelineMax({
                onComplete: () => {
                    this.removeChild(this._winAnimation);
                    this.setVisibleForSymbol(true);
                },
                onStart: () => {
                    this.setVisibleForSymbol(false);
                    this._winAnimation.alpha = 1;
                }
            }));
            this._timeLine.add(new SpineTween(this._winAnimation, 0, "s_landing")).duration();
        }
    }

    public static parseStackedSymbolName(symName: string, reelId: number): IParsedStackedSymbolName {
        if (symName == null) {
            debugger;
            throw new Error(`StackedReelSymbol.parseStackedSymbol(): symName cannot be null!`);
        }
        if (WGGameConfig.instance.WG_STACKED_SYMBOLS == null) {
            return {
                isStacked: false,
                symName: symName,
                totalNum: 1,
                index: 0
            }
        }

        const names: string[] = symName.split("*");
        let isStacked: boolean = (<any>WGGameConfig.instance.WG_STACKED_SYMBOLS)[names[0]] != null;
        return {
            isStacked: isStacked,
            symName: names[0],
            totalNum: isStacked ? (typeof (WGGameConfig.instance.WG_STACKED_SYMBOLS [names[0]].totalNum) === "number" ? <number>WGGameConfig.instance.WG_STACKED_SYMBOLS [names[0]].totalNum : (<number[]>WGGameConfig.instance.WG_STACKED_SYMBOLS [names[0]].totalNum)[reelId]) : 1,
            index: isStacked ? parseInt(names[1]) : 0
        };
    }

    get isWild(): boolean {
        return (this.symName.indexOf("W") > -1);
    }
}
